import { Type, Validator } from "../../../index";
import { Upload } from "./Upload";
import React from "react";
import { FieldRenderProps } from "react-final-form";

export interface UploadFieldOptions {
  accept: string[];
  multiple?: boolean;
}

export const UploadField = (
  options: UploadFieldOptions,
  ...validators: Validator[]
) =>
  new Type({
    Component: (props: FieldRenderProps<File | File[]>) => (
      <Upload {...options} {...props} />
    ),
    validators: validators
  });
